'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const MoneyPoundBoxIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M15.13 8.1C14.6 7.57 13.87 7.25 13.06 7.25C11.44 7.25 10.13 8.56 10.13 10.18V16.5M8.51 16.5H15.5M8.5 12.34H14.26M20.25 21.25H3.75C3.2 21.25 2.75 20.8 2.75 20.25V3.75C2.75 3.2 3.2 2.75 3.75 2.75H20.25C20.8 2.75 21.25 3.2 21.25 3.75V20.25C21.25 20.8 20.8 21.25 20.25 21.25Z",
        stroke: "currentColor"
      }
    )
  }
);
const VpMoneyPoundBoxIcon = forwardRef(MoneyPoundBoxIcon);

export { VpMoneyPoundBoxIcon as default };
